<template lang="pug">
  .ScrollIndicator(:class="elClasses")
    .ScrollIndicator_label {{ $t('scroll.label') }}
    .ScrollIndicator_icon
      RadialProgress(
        :progress="progress"
        :diameter="40"
        :startAngle="-180"
      )
</template>

<script>

import RadialProgress from '@/components/RadialProgress'

export default {
  components: {
    RadialProgress
  },
  props: {
    progress: {
      default: 0
      // validator (val) {
      //   return val >= 0 && val <= 1
      // }
    },
    orientation: {
      type: String,
      default: 'vertical',
      validator (value) {
        return value === 'vertical' || value === 'horizontal'
      }
    }
  },
  computed: {
    elClasses () {
      return {
        [`is-${this.orientation}`]: true
      }
    }
  },
  watch: {
    progress (value) {
      if (value > 0 && value < 1) { this.$el.querySelector('.ScrollIndicator_icon').classList.add('scrolled') } else { this.$el.querySelector('.ScrollIndicator_icon').classList.remove('scrolled') }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .ScrollIndicator
    position: absolute
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    color $beige
    will-change transform

    &.is-vertical
      top 50%
      right 20px
      transform translate(0, -50%) rotateZ(-90deg) translate(50%, 0)
      transform-origin: 100% 100%

      @media $mq_m
        top 50%
        right 50px

    &.is-horizontal

      bottom 20px
      right 20px
      transform-origin: 50%

      @media $mq_m
        bottom 50px
        right 50px

    &_label
      font-size 10px
      line-height @font-size
      text-transform: uppercase
      margin: 0 10px 0
      letter-spacing: .6em

      @media $mq_m
        font-size 12px
        margin: 0 20px 0

    &_icon
      padding-left 30px

      @media $mq_m
        padding-left 50px

      &.scrolled

        &:after

          animation none

      // dot
      &::before
        content ''
        position: absolute
        top 50%
        right 20px
        transform translate(50%,-50%)
        background-color currentColor
        width 7px
        height @width
        border-radius: (@width/2)

      &::after
        content ''
        position: absolute
        top 50%
        right 20px
        transition all 1s linear
        transform translate(0,-50%)
        background-color currentColor
        width 50px
        height 1px
        animation indicMobile 1s linear alternate infinite

        @media $mq_m
          width 70px
          animation indicDesk 1s linear alternate infinite

    .RadialProgress
      color $beige

@keyframes indicMobile
  from
    width 50px
  to
    width 35px

@keyframes indicDesk
  from
    width 70px
  to
    width 35px

</style>
